// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class ContactUsAPI extends MainAPI {
	/** 
	 * @param {*} contactUsDetails
	 */
	async postContactUs(contactUsDetails) {
		return API.post(ENDPOINTS.POST_CONTACT_US, contactUsDetails);
	}
}

export default new ContactUsAPI();